import React from "react";
import {
  createStyles,
  Theme,
  makeStyles,
  Container,
  Grid,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import InfoPageTemplate from "./InfoPageTemplate";
import AboutLeftTemplate from "./AboutLeftTemplate";
import AboutHistory from "./AboutHistory";
import MetaSeo from "../../../components/MetaSeo";

interface DesLaborFestivalProps {
  history: History;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    sectionRoot: {
      background: "white",
      // minHeight: "70vh",
      marginTop: "12rem",
      marginBottom: "12rem",
      //   padding: "0 4.948% 109px 4.948%",
      paddingLeft: "6rem",
      paddingRight: "6rem",
      [theme.breakpoints.down("xs")]: {
        marginTop: 32,
        marginBottom: 0,
        paddingTop: 32,
        paddingLeft: 32,
        paddingRight: 32,
      },
    },
    sectionRoot2: {
      background: "white",
      // minHeight: "55vh",
      // marginTop: "8%",
      marginBottom: "8%",
      //   padding: "0 4.948% 109px 4.948%",
      // paddingLeft: "6rem",
      // paddingRight: "6rem",
      // paddingTop: "56.25%",
      // backgroundSize: "100%",
      // backgroundPosition: "50% 50%",
    },
    likeImg: {
      // backgroundColor: "#F6D300",
    },
    likeImgTitle: {
      // color: "#1dacd6",
      color: "#0f4c81",
      // color: "#418FDE",
      textAlign: "center",
      fontSize: 48,
      // fontWeight: 900,
      // fontFamily: "Gothic A1",
      fontFamily: `"62570체"`,
      paddingBottom: 56,
      [theme.breakpoints.down("xs")]: {
        fontSize: 32,
        paddingBottom: 0,
      },
    },
    likeImgSubtilte: {
      fontFamily: "Noto Serif KR",
      fontWeight: 900,
      fontSize: 48,
      color: "#fff",
      textAlign: "center",
      [theme.breakpoints.down("xs")]: {
        fontSize: 24,
      },
    },
    hanTitle: {
      fontFamily: "Noto Serif KR",
      fontSize: 40,
      position: "absolute",
      zIndex: -1,
      top: "50%",
      left: "63%",
      fontWeight: 700,
      color: "black",
      [theme.breakpoints.down("xs")]: {
        fontSize: 24,
      },
    },
    infoTitle: {
      fontSize: 20,
      [theme.breakpoints.down("xs")]: {
        fontSize: 16,
      },
    },
    spanConnect: {
      fontWeight: 900,
      fontSize: 28,
      [theme.breakpoints.down("xs")]: {
        fontSize: 16,
      },
    },
    secOne: {
      paddingBottom: "12rem",
      [theme.breakpoints.down("xs")]: {
        paddingBottom: "2rem",
      },
    },
    liStyle: {
      paddingBottom: 40,
      fontFamily: "Noto Sans KR",

      [theme.breakpoints.down("xs")]: {
        fontSize: 16,
        paddingBottom: 16,
      },
    },
  })
);

function AboutPageSection() {
  const classes = useStyles();

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));
  const metaData = {
    title: "노동인권문화제 소개",
    description:
      "문화제의 각종 공모 프로그램과 본 행사를 통해 부산시민과 노동자 그리고 청소년의 참여를 통해 일반시민들에게 보다 친근하고 재밌게 다가가 노동의 의미와 자긍심을 되새기고, 노동과 인권이 존중되는 지역사회 분위기 조성 및 사회전체의 노동인권 감수성 함양",
    canonical: "http://laborbusan.or.kr/about/",
  };

  return (
    <Container
      maxWidth={false}
      disableGutters={true}
      className={classes.sectionRoot}
    >
      <MetaSeo data={metaData} />
      <Container
        maxWidth={"xl"}
        disableGutters={true}
        className={classes.secOne}
        // style={{ paddingBottom: "6rem" }}
      >
        {/* <InfoPage /> */}
        <InfoPageTemplate
          categoryInfo={null}
          title={
            <div>
              {" "}
              노동인권문화제{"\u00A0"}
              {"\u00A0"}소개
            </div>
          }
          describe={
            <div>
              <Grid
                xs={12}
                item
                style={{ paddingBottom: 24 }}
                className={classes.infoTitle}
              >
                (사)노동인권연대가 주관하는 노동인권문화제는
                {!matches ? <br /> : ""}
                2019년을 시작으로 부산시민의 노동인권과 사회연대의식 함양을
                도모합니다.
                {!matches ? <br /> : ""} 이를 통해 부산이 성숙한 민주 시민사회를
                선도하는 도시로 발전하도록
                {!matches ? <br /> : ""}다양한 시민참여형 축제문화를
                만들어나가고 있습니다.
              </Grid>
              <Grid
                xs={12}
                item
                style={{ paddingBottom: 24 }}
                className={classes.infoTitle}
              >
                노동인권문화제는 다변화 시대에 서로를 잇는{" "}
                {!matches ? "" : <br />}
                <span className={classes.spanConnect}>‘연결’</span>
                이라는 화두 속에 과거, 현재, 미래의 노동을 재조명하고
                {!matches ? <br /> : ""}
                노동과 인권이 존중되는 지역사회 분위기 조성 및 사회 전체의
                노동인권 감수성을 지속적으로 확산시키고자 합니다.
              </Grid>
            </div>
          }
        />
        {/* <FutureLeftImg /> */}

        <AboutLeftTemplate
          image={
            <div style={{ color: "yellow" }}>
              <div className={classes.likeImg}>
                <div>
                  <div className={classes.likeImgTitle}>노동인권문화제</div>
                  <div className={classes.likeImgSubtilte}>
                    노동인권展 - 노동,다시보기
                  </div>
                </div>
              </div>
              <div className={classes.hanTitle} style={{}}>
                多see
              </div>
            </div>
          }
          describe={
            <ul
              style={{
                margin: 0,
                listStyle: "outside",
              }}
            >
              <li className={classes.liStyle}>
                문화제의 각종 공모 프로그램과 본 행사를 통해 부산시민과 노동자
                <br />
                그리고 청소년의 참여를 통해 일반시민들에게 보다 친근하고 재밌게
                <br />
                다가가 노동의 의미와 자긍심을 되새기고, 노동과 인권이 존중되는
                <br />
                지역사회 분위기 조성 및 사회전체의 노동인권 감수성 함양
              </li>
              <li className={classes.liStyle}>
                부산의 지역적 특수성을 고려한 다양한 노동자계층(비정규직,
                중소기업 노동자,
                <br /> 특수고용직 등)이 시민들과 소통하고 공감 할 수 있는 축제와
                놀이공간으로서의
                <br /> 문화제
              </li>
              <li className={classes.liStyle}>
                시민사회단체 및 노동 예술계와의의 다양한 협업을 통해
                <br /> 지역 내 다양한 노동문화 형성 및 노동 콘텐츠 확산
              </li>
            </ul>
          }
        />
      </Container>
      {!matches ? <AboutHistory /> : <div></div>}
    </Container>
  );
}

export default AboutPageSection;
